import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-marketing-confirmation',
  templateUrl: './marketing-confirmation.component.html',
  styleUrls: ['./marketing-confirmation.component.scss']
})
export class MarketingConfirmationComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

}
